<template>
  <div ref="chart" class="echarts"></div>
</template>

<script>
/* eslint-disable */
import * as echarts from 'echarts'

export default {
  name: 'LineColumn',
  props: {
    title: {
      type: String,
      default: '',
    },
    echartsOption: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chart: '',
      option: {
        title: {
          text: this.title,
          top: 0,
          left: 0,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal',
          },
        },
        yAxis: [{
          type: 'value',
        }],
        grid: {
          left: '16px',
          right: '16px',
          bottom: '0%',
          top: '20%',
          containLabel: true,
        },
        tooltip: {
          triggerOn: 'mousemove',
          trigger: 'axis',
          formatter(params) {
            console.log('--x轴类目对应的参数数组--', params)
            let res = `<div style="font-size: 12px;font-weight: bold;margin-bottom:5px;padding:0 12px;width:100%;height:24px;line-height:24px;border-radius:3px;"><p>${params[0].name}</p></div>`
            for (let i = 0; i < params.length; i++) {
              res += `<div style="font-size: 12px; padding:0 12px;line-height: 24px">
                <span style="display:inline-block;margin-right:5px;border-radius:2px;width:10px;height:10px;background-color:${[params[i].color]};"></span>
                ${params[i].seriesName}
                ${params[i].value}
                </div>`
            }
            return res
          },
        },
        series: [],
        xAxis: [
          {
            data: [],
          },
        ],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$refs.chart)
      this.setOption()
    },
    setOption() {
      this.option = Object.assign({}, this.option, this.echartsOption)
      this.chart.setOption(this.option)
    },
  },
}
</script>

<style lang="scss" scoped>
.echarts{
  margin-top: 10px;
  margin-bottom: 30px;
  width: 100%;
  height: 410px;
}
</style>
